import * as React from 'react'
import * as css from './ToggleMobileMenu.module.css'
import { GlobalContext } from '../Store'
import clsx from 'clsx'

const ToggleMobileMenu = ({ transparent }) => {
  const { mobileMenuState, setMobileMenuState } = React.useContext(GlobalContext)

  const toggleMobileMenu = () => setMobileMenuState(!mobileMenuState)

  return (
    <button
      className={clsx(css.root, (transparent && !mobileMenuState) && 'text-shadow', 'md:!hidden')}
      onClick={toggleMobileMenu}
    >
      {mobileMenuState ? '×' : '≡'}
    </button>
  )
}

export default ToggleMobileMenu
